function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var TAGGED_PURCHASED_NOUN_SOURCE = 'tnpr';
export var INDUSTRIES_SOURCE = 'inpr';
export var PURCHASED_SOURCE = 'purchased';
export var PURCHASED_NOUN_SOURCE = 'pnpr';
export var NOUN_PROJECT_SOURCE = 'npr';
export var WIX_CMS_SOURCE = 'wixcms';
export var NEW_WIX_CMS = 'newWixCms';
export var NEW_CMS = 'NEW_WIX_CMS';
export var WIX_NOUN_PROJECT_SOURCE = 'wixNpr';
export var WIX_SOURCE = 'wix';
export var LOGO_CMS_NOUN = 'LOGO_CMS_NOUN';
export var NOUN_PROJECT = 'NOUN_PROJECT';
export var PAID_NOUN_PROJECT = 'PAID_NOUN_PROJECT';
export var WIX = 'WIX';
export var WIX_CMS = 'WIX_CMS';
export var NEW_NOUN_PROJECT = 0;
export var NEW_PAID_NOUN_PROJECT = 1;
export var NEW_WIX = 2;
export function fromOldIconToNewIcon(oldIcon) {
  var id = oldIcon.id,
      oldSource = oldIcon.source;
  var newSource;

  switch (oldSource) {
    case TAGGED_PURCHASED_NOUN_SOURCE:
    case INDUSTRIES_SOURCE:
    case PURCHASED_SOURCE:
    case PURCHASED_NOUN_SOURCE:
      newSource = PAID_NOUN_PROJECT;
      break;

    case NOUN_PROJECT_SOURCE:
      newSource = NOUN_PROJECT;
      break;

    case WIX_CMS_SOURCE:
      newSource = WIX_CMS;
      break;

    case WIX_SOURCE:
    case WIX_NOUN_PROJECT_SOURCE:
      newSource = WIX;
      break;

    case WIX:
    case WIX_CMS:
    case NOUN_PROJECT:
    case PAID_NOUN_PROJECT:
    case LOGO_CMS_NOUN:
    case NEW_CMS:
      // Already new
      newSource = oldSource;
      break;

    case NEW_WIX_CMS:
      newSource = NEW_CMS;
      break;

    default:
      throw new Error("fromOldIconToNewIcon - Unrecognized icon source: id: " + id + " | source: " + oldSource);
  }

  return _objectSpread(_objectSpread({}, oldIcon), {}, {
    source: newSource
  });
}
export function fromNewIconToOldIcon(newIcon) {
  var id = newIcon.id,
      newSource = newIcon.source;
  var oldSource;

  switch (newSource) {
    case PAID_NOUN_PROJECT:
    case NEW_PAID_NOUN_PROJECT:
      oldSource = PURCHASED_NOUN_SOURCE;
      break;

    case NOUN_PROJECT:
    case NEW_NOUN_PROJECT:
      oldSource = NOUN_PROJECT_SOURCE;
      break;

    case WIX_CMS:
      oldSource = WIX_CMS_SOURCE;
      break;

    case WIX:
    case NEW_WIX:
      oldSource = WIX_NOUN_PROJECT_SOURCE;
      break;

    case NEW_WIX_CMS:
      oldSource = NEW_CMS;
      break;

    case LOGO_CMS_NOUN:
    case NEW_CMS:
      oldSource = newSource;
      break;

    default:
      throw new Error("fromNewIconToOldIcon - Unrecognized icon source: id: " + id + " | source: " + newIcon);
  }

  return _objectSpread(_objectSpread({}, newIcon), {}, {
    source: oldSource
  });
}